// extracted by mini-css-extract-plugin
module.exports = {"Crossout":"Styles_Crossout__3PCdw"};